import { useState, type ReactNode, type SyntheticEvent } from "react";
import { useNavigate } from "react-router-dom";

import { collectionPath, useCreateCollection } from "../api/queries";
import { Button } from "../ui/Button";
import { Dialog } from "../ui/Dialog";

export function NewCollectionDialog({
  open,
  onClose,
}: {
  open: boolean;
  onClose: () => void;
}): ReactNode {
  const [name, setName] = useState("");
  const navigate = useNavigate();
  const create = useCreateCollection();

  const submit = (event: SyntheticEvent): void => {
    event.preventDefault();
    const trimmed = name.trim();
    if (trimmed === "") return;
    create.mutate(
      { name: trimmed },
      {
        onSuccess: (collection) => {
          setName("");
          onClose();
          void navigate(collectionPath(collection));
        },
      },
    );
  };

  return (
    <Dialog open={open} onClose={onClose} title="New collection" width="sm">
      <form onSubmit={submit} className="flex flex-col gap-3">
        <label className="flex flex-col gap-1 text-sm">
          Name
          <input
            value={name}
            onChange={(event) => {
              setName(event.target.value);
            }}
            required
            className="rounded-md border border-line bg-canvas px-3 py-2 text-sm"
          />
        </label>
        {create.isError && (
          <p role="alert" className="text-sm text-danger">
            {create.error.message}
          </p>
        )}
        <div className="flex justify-end gap-2">
          <Button onClick={onClose}>Cancel</Button>
          <Button type="submit" variant="primary" disabled={create.isPending}>
            {create.isPending ? "Creating…" : "Create"}
          </Button>
        </div>
      </form>
    </Dialog>
  );
}
